import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from "react-i18next";

export default function LoginPage({ embedded = false }) {
  const { t } = useTranslation();
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    setLoading(true);
    const result = await login(email, password);
    setLoading(false);

    if (result.success) {
      const isProvider = result.profile?.role === "guide" || result.profile?.role === "driver";
      navigate(isProvider ? "/dashboard" : location.state?.from || "/dashboard");
    } else {
      setError(t(result.errorKey || "auth.invalid_credentials"));
    }
  };

  return (
    <main className={embedded ? "flex items-center justify-center py-2 sm:py-4" : "min-h-[calc(100svh-68px)] flex items-center justify-center p-6 bg-[#F7F6F3] dark:bg-slate-950 transition-colors duration-300"}>
      <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-3xl p-8 max-w-md w-full shadow-lg">
        <h2 className="font-serif text-3xl font-bold text-slate-900 dark:text-slate-100 text-center mb-2">
          {t("auth.login_title", "Вход в аккаунт")}
        </h2>
        <p className="text-sm text-slate-500 dark:text-slate-400 text-center mb-6">
          {t("auth.login_subtitle", "Добро пожаловать обратно в UzTravel")}
        </p>

        {error && (
          <div className="mb-4 p-3 rounded-xl bg-red-500/10 border border-red-500/20 text-red-500 text-xs font-semibold text-center">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div>
            <label className="text-xs font-bold text-slate-600 dark:text-slate-300 mb-1 block">
              {t("auth.email_label")}
            </label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t("auth.email_placeholder")}
              className="w-full bg-[#FAF8F5] dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-2xl px-4 py-3 text-slate-900 dark:text-slate-100 text-sm focus:outline-none focus:ring-2 focus:ring-amber-400"
            />
          </div>

          <div>
            <label className="text-xs font-bold text-slate-600 dark:text-slate-300 mb-1 block">
              {t("auth.password_label")}
            </label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t("auth.password_placeholder")}
              className="w-full bg-[#FAF8F5] dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-2xl px-4 py-3 text-slate-900 dark:text-slate-100 text-sm focus:outline-none focus:ring-2 focus:ring-amber-400"
            />
          </div>

          <button
            type="submit" disabled={loading}
            className="w-full mt-2 bg-amber-400 hover:bg-amber-300 active:scale-[0.98] text-slate-950 font-bold py-3 rounded-2xl shadow-md transition-all text-sm"
          >
            {loading ? t("auth.loading") : t("auth.login_btn", "Войти")}
          </button>
        </form>

        <p className="mt-6 text-center text-xs text-slate-500 dark:text-slate-400">
          {t("auth.no_account", "Ещё нет аккаунта?")}{" "}
          <Link to="/register" className="text-amber-600 dark:text-amber-400 font-bold hover:underline">
            {t("auth.register_link", "Зарегистрироваться")}
          </Link>
        </p>
      </div>
    </main>
  );
}
